import { Flex, UseDisclosureReturn } from '@chakra-ui/react';
import { EntityNoteModel } from '../../globalModels/entityNotes/entityNoteModel';
import { EntityNoteType } from '../../enums/common/EntityNoteType';
import { ApiEndpoints } from '../../constants/endpoints/apiEndpoints.ts';

import { BaseFormPopover, createFieldHelper, useHookForm, useStandardToast } from '@cks-internal/react-base';
import { useEntityNoteMutation } from './apis/useEntityNoteMutation';
import { EntityNoteQueryType } from '../../enums/common/EntityNoteQueryType';
import { companyCrmFlexGap } from '../company/overview/utils/common';
import { PropsWithChildren } from 'react';

type IEntityNotesDialog = PropsWithChildren & {
  disclosure: UseDisclosureReturn;
  model?: EntityNoteModel;
  id?: number;
  queryType: EntityNoteQueryType;
};

export const EntityNotesPopover = (props: IEntityNotesDialog) => {
  const toast = useStandardToast();
  const { formMethods } = useHookForm<EntityNoteModel>(
    props.model
      ? props.model
      : {
          IsDisabled: false,
          IsPinned: false,
          Note: '',
          EntityNoteType: EntityNoteType.Basic
        }
  );
  const helper = createFieldHelper<Partial<EntityNoteModel>>(formMethods);
  const createNoteMutation = useEntityNoteMutation();

  const baseFields = [
    helper.hiddenInput('Id'),
    helper
      .textArea('Note')

      .withValidation({ required: { message: 'A Note is required' } })
      .withLabel('Note'),
    helper
      .selectInputQueryItems('EntityNoteType', { searchUrl: ApiEndpoints.selectOptions.enum('EntityNoteType', true) })
      .withLabel('Note Type')
  ];

  const onSubmit = async (formModel: EntityNoteModel) => {
    await createNoteMutation.mutateAsync({ noteType: props.queryType, id: props.id, model: formModel });
    props.disclosure.onClose();
    toast.successToast('Success', 'Updated Note');
  };

  return (
    <BaseFormPopover<EntityNoteModel>
      trigger={props.children}
      formControlProps={{
        onCancel: () => {
          formMethods.reset();
          props.disclosure.onClose();
        }
      }}
      formMethods={formMethods}
      disclosure={props.disclosure}
      onSubmit={(val) => onSubmit(val)}>
      <Flex gap={companyCrmFlexGap} flexDir={'column'} w={'100%'}>
        {helper.renderFieldHelperInput('EntityNoteType', baseFields)}
        {helper.renderFieldHelperInput('Note', baseFields)}
      </Flex>
    </BaseFormPopover>
  );
};
